import React, { Component } from "react";
import ws from ".";
import { connect } from "react-redux";
import { recieveMsg, sendMsg } from "../redux/actions/Socket.Action";
class SocketComponent extends Component { 
  componentDidMount() {
    ws.onerror = (e) => {
      // console.error("ws error form comp", e);
    };
    ws.onclose = (e) => {
      // console.log("ws close form comp", e);
    };
    ws.addEventListener("open", (e) => {
      // console.log("ws message received comp", e);
    });

    ws.addEventListener("message", (event) => {
      // console.log("ws message received socke", event.data);
      const payload = JSON.parse(event.data);
      if (payload.type) {
        this.props.recieveMsg(payload);
      }
    });
    this.interval = setInterval(() => {
      this.props.sendMsg("ping");
    }, 13000);
    return () => clearInterval(this.interval);
  }
  render() {
    return <></>;
  }
  componentWillUnmount() {
    ws.close();
    console.log("component will unfound new open");
    // clearInterval(this.interval);
  }
}

export default connect(() => ({}), {
  recieveMsg,
  sendMsg,
})(SocketComponent);
